import React, { useRef } from "react";
import {
  motion,
  useScroll,
  useTransform,
  useMotionValueEvent,
} from "framer-motion";

const NetworkCapacity = () => {
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = React.useState(0);

  const utpannData = [
    {
      letter: "U",
      title: "Universal",
      desc: "UTPANN provides a universal organic solution designed to support sustainable agriculture. It helps farmers improve soil fertility while promoting environmentally responsible farming practices.",
    },
    {
      letter: "T",
      title: "Trusted",
      desc: " UTPANN is a trusted partner for farmers and distributors across the network. With consistent quality and reliable supply, it builds confidence in organic fertilizer solutions.",
    },
    {
      letter: "P",
      title: "Productive",
      desc: "UTPANN enhances crop productivity by delivering nutrient-rich organic fertilizer produced through advanced bio-gas technology. It supports healthier plant growth and improved agricultural outcomes.",
    },
    {
      letter: "A",
      title: "Agricultural",
      desc: "UTPANN is dedicated to strengthening the agricultural ecosystem. By promoting organic inputs, it helps farmers move toward more sustainable and efficient farming methods.",
    },
    {
      letter: "N",
      title: "Natural",
      desc: "UTPANN fertilizers are derived from natural organic waste processed through scientific methods. This ensures a chemical-free, eco-friendly solution that improves soil health.",
    },
    {
      letter: "N",
      title: "Nurturing",
      desc: "UTPANN nurtures both the environment and farming communities. By converting organic waste into valuable fertilizer, it supports circular resource use and reduces environmental impact.",
    },
  ];

  // 1. Track scroll progress of the container
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"],
  });

  // 2. Update the active index based on scroll position
  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    // Calculate index: divide 100% scroll into equal segments
    const segment = 1 / utpannData.length;
    const newIndex = Math.min(
      Math.floor(latest / segment),
      utpannData.length - 1,
    );
    if (newIndex !== activeIndex) {
      setActiveIndex(newIndex);
    }
  });

  return (
    /* Set height to 400vh to define how "long" the scroll lasts */
    <section ref={containerRef} className="relative h-[400vh] bg-[#031312]">
      {/* Sticky container stays in viewport */}
      <div className="sticky top-0 flex items-center justify-center w-full h-screen overflow-hidden bg-[linear-gradient(153deg,#195939_0%,#031312_100%)]">
        <div className="w-full max-w-[1920px] px-4 md:px-[56px] flex flex-col items-center">
          {/* Letters Row */}
          <div className="flex justify-center items-baseline mb-[-20px] md:mb-[-40px] select-none">
            {utpannData.map((item, index) => (
              <motion.span
                key={index}
                animate={{
                  color: activeIndex === index ? "#FFFFFF" : "#759b88",
                  scale: activeIndex === index ? 1.1 : 1,
                  opacity: activeIndex === index ? 1 : 0.4,
                }}
                transition={{ duration: 0.3 }}
                className="font-[parkinsans] font-bold 
                           text-[60px] 
                           sm:text-[100px] 
                           lg:text-[200px] 
                           2xl:text-[350px] 
                           leading-none transition-all duration-300"
              >
                {item.letter}
              </motion.span>
            ))}
          </div>

          {/* Content Area with Animation Key */}
          <motion.div
            key={activeIndex} // Re-triggers animation when index changes
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col items-center gap-4 w-full max-w-[1496px] mt-[40px] md:mt-[100px]"
          >
            <h2 className="text-[22px] md:text-[30px] font-poppins font-bold text-white tracking-wider">
              {utpannData[activeIndex].title}
            </h2>

            <p className="text-[18px] md:text-[24px] font-poppins font-light leading-relaxed text-center text-white/90">
              {utpannData[activeIndex].desc}
            </p>

            {/* Visual Progress Bar */}
            {/* <div className="flex gap-2 mt-8">
              {utpannData.map((_, i) => (
                <div
                  key={i}
                  className={`h-1.5 rounded-full transition-all duration-500 ${
                    activeIndex === i ? "w-12 bg-white" : "w-3 bg-white/20"
                  }`}
                />
              ))}
            </div> */}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default NetworkCapacity;
